var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRevenueStreamlineFlex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "-0.645 -0.645 18 18",
    id: "Revenue--Streamline-Flex",
    height: 18,
    width: 18,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n    Revenue Streamline Icon: https://streamlinehq.com\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "revenue--money-banknote-earnings",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.29
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.0 5.2h12.7a1.3 1.3 0 0 1 1.3 1.3v4.7a1.3 1.3 0 0 1 -1.3 1.3H2.0a1.3 1.3 0 0 1 -1.3 -1.3V6.5a1.3 1.3 0 0 1 1.3 -1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.355 10.85a2.0 2.0 0 1 1 0 -4.0 2.0 2.0 0 0 1 0 4.0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.3 7.65v2.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4 7.65v2.4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevenueStreamlineFlex);
export default __webpack_public_path__ + "static/media/Revenue--Streamline-Flex.35d6cf0c9c6714a3444e33b5e6200372.svg";
export { ForwardRef as ReactComponent };